import { render, staticRenderFns } from "./EditProjectDialog.vue?vue&type=template&id=35049c98&scoped=true&"
import script from "./EditProjectDialog.vue?vue&type=script&lang=js&"
export * from "./EditProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectDialog.vue?vue&type=style&index=0&id=35049c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35049c98",
  null
  
)

export default component.exports